import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../recoil/cashout/ClientSideConfigSelector';
import CashoutTaxForm from './forms/CashoutTaxForm';
import Loading from '../../general/Loading';
import useHttpRequest from '../../api/HttpRequest';

export default function CashoutTaxFaq() {
  const { t } = useTranslation(null, { useSuspense: false });
  const httpRequest = useHttpRequest();

  const [taxProvider, setTaxProvider] = useState(null);

  const [loading, setLoading] = useState(true);

  const [showForm, setShowForm] = useState(false);

  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        paymentProvider: provider,
      } = {},
    } = {},
  } = config || {};

  useEffect(() => {
    setLoading(true);

    try {
      const initialize = async () => {
        const result = await httpRequest.send(
          '/web-payments/cash-reward/provider',
        );
        setTaxProvider(result.taxProvider);
        setLoading(false);
      };

      initialize();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error fetching cashout tax provider...', err);
    }
  }, []);

  if (loading) {
    return <Loading />;
  }

  const isDisplayTaxForm = taxProvider && taxProvider !== 'none';

  return (
    <>
      <div className="member-diamonds-educate">
        <h3>{t('tax_faq_title')}</h3>

        {isDisplayTaxForm && (
          <>
            <p className="educate-diamonds-faq-question">
              {t('tax_fax_why_i_being_asked_to_complete_a_form_question')}
            </p>

            <p>
              {t('tax_fax_why_i_being_asked_to_complete_a_form_answer')}
            </p>

            {provider === 'wire' && (
              <>
                <p className="educate-diamonds-faq-question">
                  {t('tax_fax_why_am_i_being_contacted_about_cash_reward_request_question')}
                </p>

                <p>
                  {t('tax_fax_why_am_i_being_contacted_about_cash_reward_request_answer')}
                </p>
              </>
            )}

            <p className="educate-diamonds-faq-question">
              {t('tax_fax_what_if_i_need_to_update_a_tax_form_question')}
            </p>

            <p>
              {t('tax_fax_what_if_i_need_to_update_a_tax_form_link_question')}
              <button
                type="button"
                className="btn-link cashout-taxbandits-registration-link"
                onClick={() => setShowForm(true)}
              >
                {t('cashout_provider_legal_confirmation_message_footer')}
              </button>
              {' '}
              {t('tax_fax_what_if_i_need_to_update_a_tax_form_link_answer')}
            </p>
          </>
        )}
        <p className="educate-diamonds-faq-question">
          {t('tax_fax_are_rewards_taxable_question')}
        </p>

        <p>
          {t('tax_fax_are_rewards_taxable_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_will_my_reward_reported_to_irs_question')}
        </p>

        <p>
          {t('tax_fax_will_my_reward_reported_to_irs_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_what_is_form_1099_k_question')}
        </p>

        <p>
          {t('tax_fax_what_is_form_1099_k_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_what_is_form_1099_misc_question')}
        </p>

        <p>
          {t('tax_fax_what_is_form_1099_misc_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_does_the_company_withhold_taxes_question')}
        </p>

        <p dangerouslySetInnerHTML={{ __html: t('tax_fax_does_the_company_withhold_taxes_answer') }} />

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_do_i_owe_quarterly_taxes_to_irs_question')}
        </p>

        <p>
          {t('tax_fax_do_i_owe_quarterly_taxes_to_irs_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_do_i_need_to_report_rewards_if_dont_receive_a_form_question')}
        </p>

        <p>
          {t('tax_fax_do_i_need_to_report_rewards_if_dont_receive_a_form_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_why_i_being_asked_to_provide_tax_info_question')}
        </p>

        <p>
          {t('tax_fax_why_i_being_asked_to_provide_tax_info_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_are_any_of_my_business_expenses_tax_deductible_question')}
        </p>

        <p>
          {t('tax_fax_are_any_of_my_business_expenses_tax_deductible_answer')}
        </p>

        <p className="educate-diamonds-faq-question">
          {t('tax_fax_who_is_a_us_person_question')}
        </p>

        <p>
          {t('tax_fax_who_is_a_us_person_answer')}
        </p>
      </div>

      {showForm && (
        <CashoutTaxForm
          form={{
            requestForce: true,
          }}
          onContinue={async () => {
            setShowForm(false);
          }}
          onClose={async () => {
            setShowForm(false);
          }}
        />
      )}
    </>
  );
}
